export const STOCK_DOMAIN_MAP: Record<string, string> = {
  AAPL: 'apple.com',
  MSFT: 'microsoft.com',
  GOOGL: 'google.com',
  AMZN: 'amazon.com',
  TSLA: 'tesla.com',
  META: 'meta.com',
  NFLX: 'netflix.com',
  NVDA: 'nvidia.com',
  BA: 'boeing.com',
  JPM: 'jpmorganchase.com',
  GS: 'goldmansachs.com',
  BAC: 'bankofamerica.com',
  WMT: 'corporate.walmart.com',
  DIS: 'thewaltdisneycompany.com',
  CVX: 'chevron.com',
  AMD: 'amd.com',
  INTC: 'intel.com',
  ORCL: 'oracle.com',
  IBM: 'ibm.com',
  ADBE: 'adobe.com',
  PYPL: 'paypal.com',
  UBER: 'uber.com',
  LYFT: 'lyft.com',
  PFE: 'pfizer.com',
  MRNA: 'modernatx.com',
  KO: 'coca-colacompany.com',
  PEP: 'pepsico.com',
  XOM: 'corporate.exxonmobil.com',
  T: 'att.com',
  V: 'visa.com',
  MA: 'mastercard.com',
  CSCO: 'cisco.com',
  CRM: 'salesforce.com',
  COST: 'costco.com',
  AVGO: 'broadcom.com',
  TXN: 'ti.com',
  QCOM: 'qualcomm.com',
  AMAT: 'appliedmaterials.com',
  INTU: 'intuit.com',
  SBUX: 'starbucks.com',
  MCD: 'mcdonalds.com',
  LOW: 'lowes.com',
  HD: 'homedepot.com',
  CAT: 'caterpillar.com',
  HON: 'honeywell.com',
  AMGN: 'amgen.com',
  LLY: 'lilly.com',
  UNH: 'unitedhealthgroup.com',
  ABT: 'abbott.com',
  CVS: 'cvshealth.com',
  WFC: 'wellsfargo.com',
  MS: 'morganstanley.com',
  AXP: 'americanexpress.com',
  BLK: 'blackrock.com',
  C: 'citigroup.com',
  BK: 'bnymellon.com',
  TGT: 'corporate.target.com',
  NKE: 'nike.com',
  SHOP: 'shopify.com',
  SNOW: 'snowflake.com',
  PLTR: 'palantir.com',
};

export const INDEX_DOMAIN_MAP: Record<string, string> = {
  SPY: 'ssga.com',
  QQQ: 'invesco.com',
  DIA: 'ssga.com',
  IWM: 'ishares.com',
  VTI: 'vanguard.com',
  VOO: 'vanguard.com',
  XLK: 'ssga.com',
  XLF: 'ssga.com',
  XLE: 'ssga.com',
  XLY: 'ssga.com',
  XLP: 'ssga.com',
  XLV: 'ssga.com',
  XLI: 'ssga.com',
  XLB: 'ssga.com',
  XLU: 'ssga.com',
  IYR: 'ishares.com',
  SMH: 'vaneck.com',
  SOXX: 'ishares.com',
  TLT: 'ishares.com',
  HYG: 'ishares.com',
  GLD: 'ssga.com',
  SLV: 'ishares.com',
  BITO: 'proshares.com',
  SPYD: 'ssga.com',
  JEPI: 'jpmorganchase.com',
};

export function getStockLogoUrl(symbol: string): string | null {
  const domain = STOCK_DOMAIN_MAP[symbol];
  return domain ? `https://cdn.tickerlogos.com/${domain}` : null;
}

export function getIndexLogoUrl(symbol: string): string | null {
  const domain = INDEX_DOMAIN_MAP[symbol];
  return domain ? `https://cdn.tickerlogos.com/${domain}` : null;
}
